import { useMemo } from 'react';

const PasswordStrengthIndicator = ({ password }) => {
  const strength = useMemo(() => {
    if (!password) return { level: 0, text: '', color: '' };
    
    let score = 0;
    if (password?.length >= 8) score++;
    if (password?.length >= 12) score++;
    if (/[a-z]/?.test(password) && /[A-Z]/?.test(password)) score++;
    if (/\d/?.test(password)) score++;
    if (/[^a-zA-Z0-9]/?.test(password)) score++;

    if (score <= 2) return { level: 1, text: 'Weak', color: 'bg-error' };
    if (score === 3) return { level: 2, text: 'Fair', color: 'bg-warning' };
    if (score === 4) return { level: 3, text: 'Good', color: 'bg-accent' };
    return { level: 4, text: 'Strong', color: 'bg-success' };
  }, [password]);

  if (!password) return null;

  return (
    <div className="mt-2">
      <div className="flex gap-1 mb-1">
        {[1, 2, 3, 4]?.map((level) => (
          <div
            key={level}
            className={`h-1 flex-1 rounded-full transition-all duration-300 ${
              level <= strength?.level ? strength?.color : 'bg-muted'
            }`}
          />
        ))}
      </div>
      <p className="text-xs text-muted-foreground">
        Password strength: <span className="font-medium text-foreground">{strength?.text}</span>
      </p>
    </div>
  );
};

export default PasswordStrengthIndicator;